module.exports = __webpack_public_path__ + "img/circle.557210d4.svg";